import {
  HeroSection,
  SectionDivider,
  UseCaseCards,
  HowItWorks,
  Calculator,
  VaultFunding,
  CollateralTiers,
  AgentFeatures,
  styles,
} from './enaibl';

export default function EnaiblPageRedesign() {
  return (
    <section className="relative bg-black overflow-hidden">
      <style>{styles}</style>
      
      <HeroSection />
      
      <div className="max-w-[1100px] mx-auto px-4 sm:px-6 pb-52 sm:pb-[360px]">
        <SectionDivider number="01" />
        <UseCaseCards />
        
        <SectionDivider number="02" />
        <HowItWorks />
        
        <SectionDivider number="03" />
        <Calculator />
        
        <SectionDivider number="04" />
        <VaultFunding />
        
        <SectionDivider number="05" />
        <CollateralTiers />
        
        <SectionDivider number="06" />
        <AgentFeatures />
      </div>
    </section>
  );
}
